import { Link } from 'react-router-dom';
import { PencilIcon, MailIcon } from '@heroicons/react/outline';
import { Button } from '../../styles/components';

type AttachmentSectionProps = {
  children: React.ReactNode;
  isSignatureReuired?: boolean;
  id?: number;
  checked?: boolean;
  handleChange?: () => void;
  toggleSideBar?: (value: boolean) => void;
};

const AttachmentSection = ({
  children,
  isSignatureReuired = false,
  id,
  handleChange,
  checked = false,
  toggleSideBar,
}: AttachmentSectionProps) => {
  return (
    <div className="py-7">
      <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 bg-orange-500 p-3 border-2 rounded-lg">
        <div className="sm:col-span-2">
          <dt className="text-md font-medium text-white">Anhang</dt>
          <dd className="mt-1 text-sm text-gray-900 bg-white">
            <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
              {children}
            </ul>
          </dd>
          {isSignatureReuired && (
            <dd className="text-sm text-gray-900 bg-white rounded-lg mt-8">
              <ul className="border border-gray-200 rounded-md p-4">
                <h3 className="font-semibold leading-6 text-lg text-gray-700">
                  Digitale Unterschrift
                </h3>
                <p className={`font-medium sm:text-sm text-gray-500 py-2`}>
                  Mit meiner Unterschrift bestätige ich, dass ich den
                  Fahrzeugüberlassungsvertrag gelesen und verstandnen habe.
                </p>
                <div className="relative flex items-start">
                  <div className="flex h-6 items-center">
                    <input
                      checked={checked}
                      onChange={handleChange}
                      id="digital_sinature"
                      name="digital_sinature"
                      type="checkbox"
                      aria-describedby="digital_sinature-description"
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                  </div>
                  <div className="ml-2">
                    <label
                      className="text-gray-600 text-sm"
                      htmlFor="digital_sinature">
                      Ich erkläre mich mit den Inhalten dieses
                      Fahrzeugübberlassungsvertrages einverstanden.
                    </label>
                  </div>
                </div>
                <div className="flex flex-col py-3 lg:mt-0 w-full">
                  <Link
                    to={`/id_check/online_signature_pdf/${id}`}
                    className="w-full flex flex-col">
                    <Button
                      disabled={checked ? false : true}
                      className="justify-center"
                      startIcon={<PencilIcon className="w-5 h-5 mx-4" />}
                      type={checked ? 'primary' : 'disabled'}
                      size="large"
                      label="Vertrag unterschreiben"
                    />
                  </Link>
                </div>
              </ul>
            </dd>
          )}

          {toggleSideBar && (
            <dd className="text-sm text-gray-900 bg-white rounded-lg mt-8">
              <ul className="border border-gray-200 rounded-md p-4">
                <h3 className="font-semibold leading-6 text-lg text-gray-700">
                  Fahrzeugüberlassungsvertrag per E-Mail versenden.
                </h3>
                <div className="flex flex-col py-3 lg:mt-0 w-full">
                  <Button
                    className="justify-center"
                    startIcon={<MailIcon className="w-5 h-5 mx-4" />}
                    type="secondary"
                    size="large"
                    onClick={() => {
                      toggleSideBar(true);
                    }}
                    label="Email Senden"
                  />
                </div>
              </ul>
            </dd>
          )}
        </div>
      </dl>
    </div>
  );
};

export default AttachmentSection;
